import { useNavigate } from "react-router-dom";
import { PrimaryButton, SecondaryButton } from "../../Buttons";
import { DropdownCrossIcon } from "../../Icons";
import GetTransactionStatus from "../../RecentTranactions/partials/ViewRecentTransaction/partials/GetTransactionStatus";
import HelpModal from "../../Modals/HelpModal";
import { useState } from "react";

const SubAccountSideBar = ({
  account,
  onClose,
  parentClientId,
  isSumSubEnabled,
}) => {
  const navigate = useNavigate();
  const [helpModalOpen, setHelpModalOpen] = useState(false);

  if (!account) return null;

  const handleResubmit = () => {
    navigate("/create-sub-account", {
      state: {
        isSubAccount: true,
        parentClientId: parentClientId,
        isRejectedUpdate: true,
        sub_client_id: account.id,
        account_type: account.type,
      },
    });
  };

  const handleContinueApplication = () => {
    if (account.status === "In Progress") {
      navigate("/create-sub-account", {
        state: {
          isSubAccount: true,
          sub_client_id: account.id,
          sub_user_id: account.user_id,
          account_type: account.type,
        },
      });
    }
  };

  return (
    <div className="bg-gradient-primarycard rounded-3xl p-6 space-y-4 h-full relative">
      <div onClick={onClose} className="absolute top-4 right-4">
        <div className="hover:bg-background-hover rounded-full w-8 h-8 flex items-center justify-center cursor-pointer">
          <DropdownCrossIcon />
        </div>
      </div>

      <div className="pt-2">
        <h2 className="text-xl font-bold text-text-primary mb-1">
          {account.name}
        </h2>
        <p className="text-sm text-text-secondary uppercase tracking-wider">
          {account.type} Account
        </p>
      </div>

      <div className="py-4 border-t border-b border-divider space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-sm text-text-secondary">Status</span>
          <div className="flex items-center text-text-primary">
            <GetTransactionStatus status={account.status} />
          </div>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-sm text-text-secondary">Email</span>
          <span className="text-sm text-text-primary font-medium">
            {account.email || "N/A"}
          </span>
        </div>

        {account.status === "Rejected" && (
          <div className="flex justify-between items-center pt-2">
            <span className="text-sm text-text-secondary">Rejected Reason</span>
            <span className="text-sm text-error-500 font-medium bg-error-50 p-2 rounded-lg">
              {account.reject_reason || "No reason provided."}
            </span>
          </div>
        )}
      </div>

      {account.status === "Approved" && (
        <div className="pt-4">
          <p className="text-sm text-text-primary">
            Account is active and ready for use.
          </p>
        </div>
      )}

      <div className="pt-4 space-y-3">
        {!isSumSubEnabled &&  account.status === "Rejected" && (
          <PrimaryButton text="Resubmit Application" onClick={handleResubmit} />
        )}
        {account.status === "Draft" && (
          <PrimaryButton text="Continue Application" onClick={handleResubmit} />
        )}
        {!isSumSubEnabled && account.status === "In Progress" && (
          <PrimaryButton
            text="Continue Application"
            onClick={handleContinueApplication}
          />
        )}
        <HelpModal
          HelpModalOpen={helpModalOpen}
          setHelpModalOpen={setHelpModalOpen}
        >
          <SecondaryButton text="Get Help" />
        </HelpModal>{" "}
      </div>
    </div>
  );
};

export default SubAccountSideBar;
